import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Button,
  Paper
} from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import MonitorIcon from '@mui/icons-material/Monitor';
import { styled } from '@mui/material/styles';
import { getAllTeamColors } from './constants/teamColors';

const TeamColorBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  height: '8px',
  width: '100%',
  borderRadius: '4px',
  overflow: 'hidden',
  marginBottom: theme.spacing(4),
}));

const TeamColorSegment = styled(Box)<{ bgColor: string }>(({ bgColor }) => ({
  flex: 1,
  backgroundColor: bgColor,
}));

export const BattleRoyaleIndex: React.FC = () => {
  const navigate = useNavigate();
  const teamColors = getAllTeamColors();

  const menuItems = [
    {
      title: 'プレイヤー参加',
      description: 'ゲームに参加する',
      icon: <GroupsIcon sx={{ fontSize: 48 }} />,
      path: '/battle-royale/player/register',
      color: 'primary'
    },
    {
      title: 'マスター管理',
      description: 'ゲームを管理する',
      icon: <AdminPanelSettingsIcon sx={{ fontSize: 48 }} />,
      path: '/battle-royale/master/create',
      color: 'secondary'
    },
    {
      title: 'スクリーン表示',
      description: 'ランキングを表示する',
      icon: <MonitorIcon sx={{ fontSize: 48 }} />,
      path: '/battle-royale/screen',
      color: 'success'
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h3" align="center" gutterBottom fontWeight="bold">
          バトロワなぞとき交渉会
        </Typography>
        
        <Typography variant="h6" align="center" color="text.secondary" sx={{ mb: 4 }}>
          6つのチームで競い合う謎解きバトルロイヤル
        </Typography>

        <TeamColorBar>
          {teamColors.map((teamColor) => (
            <TeamColorSegment key={teamColor.color} bgColor={teamColor.colorCode} />
          ))}
        </TeamColorBar>

        <Grid container spacing={3} sx={{ mb: 4 }}>
          {menuItems.map((item) => (
            <Grid item xs={12} md={4} key={item.title}>
              <Card sx={{ height: '100%' }}>
                <CardActionArea onClick={() => navigate(item.path)} sx={{ height: '100%' }}>
                  <CardContent sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center',
                    py: 4
                  }}>
                    <Box color={`${item.color}.main`} sx={{ mb: 2 }}>
                      {item.icon}
                    </Box>
                    <Typography variant="h5" gutterBottom fontWeight="medium">
                      {item.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" align="center">
                      {item.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 4, p: 3, bgcolor: 'grey.100', borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom>
            チーム構成
          </Typography>
          <Grid container spacing={2}>
            {teamColors.map((teamColor) => (
              <Grid item xs={6} sm={4} md={2} key={teamColor.color}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      backgroundColor: teamColor.colorCode,
                      border: '2px solid',
                      borderColor: teamColor.darkColorCode,
                    }}
                  />
                  <Typography variant="body1" fontWeight="medium">
                    {teamColor.name}チーム
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            各プレイヤーは6つのチームのいずれかに所属し、チーム対抗で謎解きを競います。
          </Typography>
          <Typography variant="body2" color="text.secondary">
            正解した謎はチーム全体のポイントとなり、最終的に最も多くのポイントを獲得したチームが優勝です。
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};